import { useEffect, useState } from 'react';

interface IProps {
  element: HTMLElement | null;
  // 1 => the entire element must be visible, 0 => only a single pixel of the element needs to be visible
  threshold?: number;
  disabled?: boolean;
}

const useOnScreen = ({
  element,
  threshold = 0.9,
  disabled = false,
}: IProps) => {
  const [isIntersecting, setIntersecting] = useState(true);

  useEffect(() => {
    if (disabled || !element) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIntersecting(entry.isIntersecting);
      },
      { threshold: threshold }
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, [element]);

  return isIntersecting;
};

export default useOnScreen;
